import { render, staticRenderFns } from "./CreateTermButton.vue?vue&type=template&id=77cdd694&"
import script from "./CreateTermButton.vue?vue&type=script&lang=js&"
export * from "./CreateTermButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports